module.exports = __webpack_public_path__ + "static/background-f96fec9e7aa41926aea985292b862876.png";